
<template>
  <div class="full absolute overflow-hidden bgbg">
    <div class="full absolute top-0 left-0 herobg bg-no-repeat bg-cover bg-center">
    </div>
    <div class="full absolute top-0 left-0 area">
    </div>

    <TopNav mode="light" :logo="isLarger" :home="false"></TopNav>

    <div class="absolute vela-pos">
      <img src="../assets/home/jelly-logo.svg" alt="">
      <!-- <img src="../assets/home/jelly-studio.svg" alt=""> -->
      <div class="desc font-mono">
        Luminescence is mesmerising and enchanting.<span class="hidden md:inline"><br/></span>Join me in my journey to explore the ocean.
      </div>
    </div>

    <div class="absolute arrow-down" @click="$router.push('/about')">
      <div class=" flex flex-col justify-center items-center">
        <div class="love-and-more font-serif cursor-pointer">
          EXPLORE JELLYFISH
        </div>
        <img  src="../assets/icons/circle.svg" class="mt-4  cursor-pointer flowdown" alt="">
      </div>
    </div>

  </div>
</template>

<script>
export default {
  components: {
    TopNav: require('../uis/TopNav.vue').default
  },
  data () {
    return {
      isLarger: false
    }
  },
  mounted () {
    // document.body.style.background = `rgb(1, 11, 16)`
    window.addEventListener('resize', () => {
      this.isLarger = window.innerWidth > 767
    })
    this.isLarger = window.innerWidth > 767
  },
  beforeDestroy () {
    document.body.style.background = ``
  }
}
</script>

<style lang="postcss" scoped>
.bgbg{
  background: rgb(1, 11, 16);
}
@keyframes bgpos {
  0% {
    background-size: calc(1200px / 3 * 2) calc(1200px);
    transform: translateY(-25vh);
  }
  100% {
    background-size: calc(1200px / 3 * 2) calc(1200px);
    background-position: 50% 100%;
    transform: translateY(9vh);
  }
}
.area{
  box-shadow: 0px 0px 15vmin 10vmin rgb(1, 11, 16) inset;
}
.herobg{
  background-size: calc(1200px / 3 * 2) calc(1200px);
  background-position: 50% 100%;
  transform: translateY(9vh);

  /* background-position: 50% 95%; */
  box-shadow: 0px 0px 15vmin 10vmin rgb(1, 11, 16) inset;
  background-color: rgb(1, 11, 16);
  animation: bgpos 6s ease-in-out 3s 1 normal both;
  background-image: url('../assets/bg/medium.jpg');
}

.vela-pos{
  position: absolute;
  top: calc(27%);
  width: 100%;
}

.vela-pos img{
  width: 90vmin;
  margin: auto;
}

@screen lg{
  .vela-pos{
    top: 25%;
  }
}

.desc{
  padding: 0px 12px;
  font-size: 17px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: center;
  line-height: 34px;

  text-shadow: 0px 0px 10px black, 0px 0px 20px black, 0px 0px 30px black;
}
@screen lg{
  .desc{
    font-size: 24px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    line-height: 38px;
  }
}

.arrow-down{
  bottom: 4.5%;
  left: 0%;
  width: 100%;

}

.love-and-more{
  text-shadow: 0px 0px 10px black, 0px 0px 20px black, 0px 0px 30px black;
  font-size: 12px;
  color: #FFFFFF;
  letter-spacing: 3px;
}

@keyframes flowdown {
  0%{
    opacity: 0;
    transform: scale(0.26);
  }
  15%{
    opacity: 1;
  }
  85%{
    opacity: 1;
  }
  100%{
    opacity: 0;
    transform: scale(1.25);
  }
}

.flowdown {
  width: 30px;
  animation: flowdown 1s linear 0s infinite normal both;
}
</style>
